import axios from "axios";

export async function getApi(param) {
    const response = await fetch(
        `https://cms.ucbstock.com.bd//wp-json/page/${param}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}

export async function getStock(param) {
    const response = await fetch(
        `https://cms.ucbstock.com.bd//wp-json/custom-api/v1/stocks`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}

export async function getStockTotal(param) {
    const response = await fetch(
        `https://cms.ucbstock.com.bd//wp-json/custom-api/v1/totalstocks`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}

export async function getApiHUB(param,category) {
    const response = await fetch(
        `https://cms.ucbstock.com.bd//wp-json/hub/${param}?download_category=${category}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}


export async function getResearchApi(category,sub,sector,start,end,page) {
    const response = await fetch(
        `https://cms.ucbstock.com.bd//wp-json/getResearchList/all?category=${category}&sub_cat=&${sub}&sector=${sector}&start_date=${start}&end_date=${end}&page=${page}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}



export async function getApiDownloadHUB(param,category) {
    const response = await fetch(
        `https://cms.ucbstock.com.bd//wp-json/hub/${param}?download_category=${category}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}


export async function getDetailsApi(id, slug) {
    const response = await fetch(
        `https://project.bestinbd.com/projects/web/2402IAM/api/get-req-data/${id}?type=slug&value=${slug}&image=yes&file=no&post=no`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}


export async function getChildApi(id, value) {
    const response = await fetch(
        `https://project.bestinbd.com/projects/web/2402IAM/api/get-req-data/child-pages?page_id=${id}&value=${value}&get_section=yes&image=yes&post=yes&gallery=yes`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}


export async function getSellingAgentApi(division = '', district = '') {
    const response = await fetch(
        `https://project.bestinbd.com/projects/web/2402IAM/api/get-req-data/sections?type=slug&value=selling-agents&get_section=yes&image=yes&post=yes&file=no&gallery=no&division=${division}&district=${district}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}


export async function getInitialFundData(slug) {
    const response = await fetch(
        `https://cms.ucbstock.com.bd//wp-json/service/${slug}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}
export async function getInitialMediaData(slug) {
    const response = await fetch(
        `https://cms.ucbstock.com.bd//wp-json/media/${slug}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}


export async function getFundDetailApi(slug, fund_id) {
    const response = await fetch(
        `https://project.bestinbd.com/projects/web/2402IAM/api/get-req-data/product-data?type=slug&value=${slug}&image=yes&file=yes&post=yes&fund_id=${fund_id}`,
        {
            cache: "no-store"
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}
